module.exports = __webpack_public_path__ + "img/68.9.TU.02e62b89.png";